// Filename: uicanvas.js
// Timestamp: 2017.11.19-13:42:14 (last modified)
// Author(s): bumblehead <chris@bumblehead.com>

import {
  gndom_nodeelem
} from '@bumblehead/gani/src/gndom.js'

const getglcanvas = (cfg, node) => (
  gndom_nodeelem(cfg, node, 'glcanvas'))

const isalive = (cfg, node) => Boolean(
  gndom_nodeelem(cfg, node, 'glcanvas'))

// *stylesheet* should define canvas to 100% width/height
// to obtain maximum possible offsetWidth/Height
const isvalidglcanvas = canvas =>
  canvas &&
    canvas.offsetWidth &&
    canvas.offsetHeight

const setcanvaswh = (canvas, [ w, h ]) => {
  if (canvas) {
    canvas.width = w
    canvas.height = h

    canvas.style.width = `${w}px`
    canvas.style.height = `${h}px`
  }

  return canvas
}

const resetcanvas = glcanvas => {
  if (glcanvas) {
    // below seen to cause three canvas to go dark...
    // glcanvas.width = '';
    // glcanvas.height = '';

    glcanvas.style.width = ''
    glcanvas.style.height = ''

    glcanvas = setcanvaswh(glcanvas, [
      glcanvas.offsetWidth,
      glcanvas.offsetHeight
    ])
  }

  if (!isvalidglcanvas(glcanvas)) {
    console.error('canvas must be defined with dimensions')
  }

  return glcanvas
}

const getresetglcanvas = (cfg, nd) => (
  resetcanvas(getglcanvas(cfg, nd)))

const getelemwh = elem => elem
  ? [elem.offsetWidth, elem.offsetHeight]
  : []

const getglcanvaswh = (cfg, nd) => (
  getelemwh(gndom_nodeelem(cfg, nd, 'glcanvas')))

export {
  getresetglcanvas,
  getglcanvaswh,
  isalive
}
